import {useMutation, UseMutationResult} from '@tanstack/react-query';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import creatorsUpdaters, {BulkEnqueuedResponse} from '@/api/updaters/creators';

/** Variables for the bulk add-to-list mutation targeting all filter-matching creators. */
export type AddToListsAllVariables = {
  /** The agency ID for the API path. */
  agencyId: string;
  /** The server-issued session ID that identifies the current search/filter result set. */
  searchSessionId: string;
  /** The creator group (brand) to add creators into. */
  creatorGroupId: string;
  /** Label IDs (lists) to assign to the matched creators. */
  labelIds: string[];
};

function useAddToListsAll(): UseMutationResult<
  BulkEnqueuedResponse,
  Error,
  AddToListsAllVariables
> {
  return useMutation({
    mutationKey: ['creators', 'addToListsAll'],
    mutationFn: creatorsUpdaters.addToListsAll,
    onSuccess: () => {
      raiseFlashMessage({
        status: 'success',
        message: translate(
          'Bulk add to list enqueued for all matching creators'
        ),
      });
    },
  });
}

export default useAddToListsAll;
